import React from "react"
import { useParams } from "react-router-dom"
import ReviewsListing from "../../../components/Listing/ReviewsListing"

/**
 * Admin City Reviews listing — Figma Manage City - Reviews Listing.
 * APIs: GET/POST /api/v1/admin/reviews (+ export, single, update).
 */
const AdminCityReviews = () => {
  const { cityId } = useParams()

  return (
    <ReviewsListing
      documentTitle="City Reviews | AMOK . EARTH Admin"
      showExport
      cityId={cityId}
      allowCreate
    />
  )
}

export default AdminCityReviews
